import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID, trackMetaEvent } from './lib/metaPixel';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackMetaEvent('ViewContent', {
      content_name: 'Système des Constellations Familiales™',
      content_type: 'product',
      content_ids: ['systeme-constellations-familiales-fr'],
      value: 19,
      currency: 'EUR'
    });
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3recf5n6xuth9">
      <noscript data-id="element-1" data-mp="56ntiw8hdol">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="7su7f7e1n58" />
      </noscript>
      <Hero data-id="element-3" data-mp="38m1e7yvuh5ls" />
      <ProfessionalAudience data-id="element-4" data-mp="38li9jjv7gdpp" />
      <StatsBar data-id="element-5" data-mp="38k6u2msedhir" />
      <TestimonialStrip data-id="element-6" data-mp="38nuorp9kw9z2" />
      <Problems data-id="element-7" data-mp="3dkuvm2e95gr8" />
      <Modules data-id="element-8" data-mp="3dle46si0issl" />
      <ModuleIncludes data-id="element-9" data-mp="3dlw5i3jj7x7d" />
      <Comparison data-id="element-10" data-mp="3dmfmni1cyhkc" />
      <Bonuses data-id="element-11" data-mp="3dii3iwes5q0g" />
      <PricingPack data-id="element-12" data-mp="nvj179a902mk" />
      <Guarantee data-id="element-13" data-mp="nwc2huqftzxb" />
      <Reviews data-id="element-14" data-mp="nur7k407oeyx" />
      <CostOfNotBuying data-id="element-15" data-mp="nv1284w7baay" />
      <FAQ data-id="element-16" data-mp="nxwvvh10nctl" />
      <FinalCTA data-id="element-17" data-mp="sunfgec14qjr" />
      <Footer data-id="element-18" data-mp="su42zd55eud4" />
    </main>;
}